export enum TECHNICAL_TYPE {
  ORDEN_COMPRA = 'Orden Compra',
  CONTRATO = 'Contrato',
  SENTENCIA_JUDICIAL = 'Sentencia Judicial',
  DONACION = 'Donación',
  COMODATO = 'Comodato',
  ACUERDO_INTERADMINISTRATIVO = 'Acuerdo Interadministrativo',
  DECOMISO = 'Decomiso',
}


export enum TechnicalStatus {
  NUEVO = 'Nuevo',
  TRAMITE_INGRESO = 'Trámite de ingreso',
  DEVUELTO = 'Devuelto',
  ENVIADO = 'Enviado',
  FINALIZADO = 'Finalizado',
}

export enum TechnicalStatusIds {
  NUEVO_ID = 3,
  TRAMITE_INGRESO_ID = 4,
  DEVUELTO_ID = 5,
  FINALIZADO_ID = 7,
}
export enum TechnicalTypes {
  ACTIVO_FIJO = 'Activo fijo',
  ACTIVO_FIJO_ID = 1,

  BIEN_CONSUMO = 'Bien de consumo',
  BIEN_CONSUMO_ID = 2,

}

